import styled from '@emotion/styled'
import CloseIcon from '@mui/icons-material/Close'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import { Draggable, DraggableProvided } from 'react-beautiful-dnd'
import { GovernanceField } from '../types'

interface DraggableFieldProps {
  field: GovernanceField
  index: number
  onRemoveField: (fieldId: string) => void
}

const Field = styled.div`
  border: 1px solid #0000003b;
  border-radius: 4px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 12px;
  height: 40px;
  margin-bottom: 10px;
  transition: box-shadow 0.2s ease-in-out;
  user-select: none;
`

const FieldInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const getDraggableItemStyle = (isDragging, draggableStyle) => ({
  boxShadow: isDragging ? '0px 3px 3px 0px #00000026' : 'none',
  ...draggableStyle,
})

export function DraggableField({ field, index, onRemoveField }: DraggableFieldProps) {
  return (
    <Draggable draggableId={`draggable-${field.concatenation_field_id}`} index={index}>
      {(provided: DraggableProvided, snapshot) => (
        <Field
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={getDraggableItemStyle(snapshot.isDragging, provided.draggableProps.style)}
        >
          <FieldInfo>
            <DragIndicatorIcon style={{ color: '#0000008A' }} />
            <span>{field.concatenation_field_name}</span>
          </FieldInfo>
          <CloseIcon
            onClick={() => {
              onRemoveField(field.concatenation_field_id)
            }}
            style={{ cursor: 'pointer', color: '#0000008A' }}
          />
        </Field>
      )}
    </Draggable>
  )
}
